import type {
  AdminNotificationDelivery,
  AdminNotificationDeliveryListResponse,
  AdminNotificationDeliveryResponse,
  NotificationDeliveryStatus,
} from '@mds/shared/types/notification-history';

import { api } from '@/lib/api';

/**
 * Delivery history — see `backend/docs/notification-outbox.md`.
 *
 * Read-only by design. There is no resend: a terminal row's rendered payload
 * has been erased, and anything that creates a new message needs
 * `communications.send`, which these screens do not have.
 */

/** A type alias, so it carries the index signature the client's `query` needs. */
export type NotificationQuery = {
  page?: number;
  limit?: number;
  status?: NotificationDeliveryStatus;
  notificationType?: string;
  /** Exact, normalised address — not a partial match. Use `q` for that. */
  recipient?: string;
  /** ISO 8601 with an offset, filtering createdAt. `from` cannot follow `to`. */
  from?: string;
  to?: string;
  /** Searches recipient, notification type and provider message id. */
  q?: string;
  sort?: 'createdAt' | 'updatedAt' | 'deliveredAt' | 'status' | 'attemptCount';
  direction?: 'asc' | 'desc';
};

export const listDeliveries = (query: NotificationQuery = {}) =>
  api.get<AdminNotificationDeliveryListResponse>('admin/notifications', { query });

export const getDelivery = (notificationId: string): Promise<AdminNotificationDelivery> =>
  api
    .get<AdminNotificationDeliveryResponse>(`admin/notifications/${notificationId}`)
    .then((r) => r.data);
